const SKIN_PROP = 'shipper_orders_skin';

const SKINS = {
  SKIN_CANCELLED: 'red',
  SKIN_SINGLE: 'white',
  SKIN_0: 'groupage0',
  SKIN_1: 'groupage1',
  SKIN_2: 'groupage2',
  SKIN_3: 'groupage3',
  SKIN_4: 'groupage4',
  SKIN_5: 'groupage5',
  SKIN_6: 'groupage6',
  SKIN_7: 'groupage7',
  SKIN_8: 'groupage8',
  SKIN_9: 'groupage9',
  SKIN_10: 'groupage10',
  SKIN_11: 'groupage11',
};

const setShipperOrderSkin = (shipper_order, key, total) => {
  if (shipper_order.status === 'CANCELLED') {
    return SKINS.SKIN_CANCELLED;
  }
  if (total === 1) {
    return SKINS.SKIN_SINGLE;
  }
  return SKINS[`SKIN_${key}`] || SKINS.SKIN_SINGLE;
};

export const getShipperOrdersSkin = (shipper_orders = []) => ({
  [SKIN_PROP]: shipper_orders.reduce((acc, shipper_order, key) => {
    return {
      ...acc,
      [shipper_order.id]: setShipperOrderSkin(shipper_order, key, shipper_orders.length),
    };
  }, {}),
});
